//Copyright (c) 2022 Panshak Solomon

import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

import {  createStore, applyMiddleware, compose } from 'redux'
import { Provider } from 'react-redux'
import thunk from 'redux-thunk'
import reducers from './reducers/'
import logger from 'redux-logger'
const root = ReactDOM.createRoot(document.getElementById("root"));
const store = createStore(reducers, compose(applyMiddleware(thunk,logger)))

root.render(
  <Provider store={store} >
    <App />
  </Provider>,
);